import { render, staticRenderFns } from "./CaptchaImage.vue?vue&type=template&id=94cd841e&scoped=true"
import script from "./CaptchaImage.vue?vue&type=script&lang=js"
export * from "./CaptchaImage.vue?vue&type=script&lang=js"
import style0 from "./CaptchaImage.vue?vue&type=style&index=0&id=94cd841e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cd841e",
  null
  
)

export default component.exports